<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import { FormWizard, TabContent } from "vue-form-wizard";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { ModelListSelect } from "vue-search-select";
/**
 * Tabs & accordions component
 */
export default {
  page: {
    title: "PATIENT DETAILS",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    FormWizard,
    TabContent,
    ModelListSelect,
    ckeditor: CKEditor.component,
  },
  data() {
    return {
      opentmodal: "",
      index: 2,
      antnatal_patient_data: {},
      editor: ClassicEditor,
      test: null,
      DetailsData: [],
      title: "ANTENATAL DETAILS",
      items: [
        {
          text: "Antenatal Patients",
          href: "#",
        },
        {
          text: "Detail",
          active: true,
        },
      ],
      model_id: "",
      // PAGE INFORMATION
      patient_id: this.$route.params.id,
      visit_id: this.$route.params.visit,
      // ANTENATAL FIEADS
      ant_data: {
        insurance_status: 0,
        visit_id: this.$route.params.visit,
        patientId: this.$route.params.id,
        abortion: "",
        asthma: "",
        bloodtransfusion: "",
        cardiacdisease: "",
        cesarean_section: "",
        diabetic: "",
        ectopicpregnancy: "",
        education_level: "",
        epilepsy: "",
        expecteddelivery: "",
        family_history: "",
        foetalhearrate: "",
        fundalheight: "",
        gravida: "",
        hypertension: "",
        kidney_disease: "",
        lastmenstrationperiod: "",
        majorsurgerystatus: "",
        majorsurgery: "",
        major_surgery_date: "",
        major_surgery_hospital: "",
        manualvacuumaspiration: "",
        marital_status: "",
        molarpregnancy: "",
        nextofkin: "",
        occupation: "",
        para: "",
        physicalexamination: "",
        postpartumhemorrhage: "",
        presentation: "",
        relationshipwithnexofkeen: "",
        religion: "",
        retainedplacenta: "",
        sicklecellanaemia: "",
        smoke: "",
        spouse_contact: "",
        spousename: "",
        tribe: "",
        tuberculosis: "",
        CesareanSectionmonthyear: "",
        wherecesarean_section: "",
      },
      errors: {
        occupation_error: "",
      },
      drug_prescription: {},

      // ADD PRESCRIPTION
      //  ADD PRESCRIPTION
      priscription: {
        visit_id: this.$route.params.visit,
        drug_id: "",
        is_insured: 0,
      },
      // ADD SERVICE
      service_add: {
        department: "",
        insurance_company: "",
        insurance_status: "0",
        patientId: this.$route.params.id,
        patient_service: "",
        quantity: "1",
        service: "",
        spouse_status: 0,
        service_cost: "",
        visit_id: this.$route.params.visit,
      },

      // ADD SPOUSE SERVICE
      service_spouse_add: {
        department: "",
        insurance_company: "",
        insurance_status: "0",
        patientId: this.$route.params.id,
        patient_service: "",
        quantity: "1",
        service: "",
        spouse_id: "",
        spouse_status: 1,
        service_cost: "",
        visit_id: this.$route.params.visit,
      },
    };
  },

  computed: {
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapState("antenatal", ["anteboiodata"]),
    ...mapGetters("doctor", [
      "PatientCompalints",
      "DiagnosisDetails",
      "DiagnosisStatus",
      "NotesSaveStatus",
    ]),
    ...mapGetters("visits", [
      "OrderedConsultations",
      "OrderedProcedure",
      "OrderedRadiology",
      "OrderedDental",
      "AllOrderedServices",
      "OrderServiceStatus",
    ]),
    ...mapGetters("pharmacy", ["PharmacyItems"]),
    ...mapGetters("prescriptions", ["VisitPrescription", "prescriptionStatus"]),
    ...mapGetters("services", [
      "departments",
      "labServices",
      "consultationServices",
      "radiologyServices",
      "procedureServices",
      "dentalServices",
      "antenatalServices",
    ]),
    ...mapGetters("insurance", ["PaymentType", "InsuranceServices"]),
    ...mapGetters("antenatal", [
      "AntentalSaveStatus",
      "AntePatientboiodata",
      "Religions",
      "Occupations",
      "EducationLevels",
      "Tribes",
      "Spouses",
      "patient_Antenatal_visits",
    ]),

    // GET SPOUSE SERVICES
    getSpouseService: function () {
      return this.AllOrderedServices?this.AllOrderedServices:[].filter((element) => {
        return element.spouse_status == "1";
      });
    },
    // END GET SPOUSE SERVICES

    // GET SPOUSE SERVICES
    getMotherService: function () {
      return this.AllOrderedServices.filter((element) => {
        return element.spouse_status == "0";
      });
    },
    // END GET SPOUSE SERVICES

    // FILTER SERVIVES DEPENDING ON A SELECTED DEPARTMENT
    filterSevices: function () {
      if (this.opentmodal == 1) {
        if (this.service_add.department == 1) {
          return this.consultationServices;
        } else if (this.service_add.department == 2) {
          return this.radiologyServices;
        } else if (this.service_add.department == 3) {
          return this.procedureServices;
        } else if (this.service_add.department == 4) {
          return this.labServices;
        } else if (this.service_add.department == 6) {
          return this.dentalServices;
        } else if (this.service_add.department == 7) {
          return this.antenatalServices;
        } else {
          return [];
        }
      } else {
        if (this.service_spouse_add.department == 1) {
          return this.consultationServices;
        } else if (this.service_spouse_add.department == 2) {
          return this.radiologyServices;
        } else if (this.service_spouse_add.department == 3) {
          return this.procedureServices;
        } else if (this.service_spouse_add.department == 4) {
          return this.labServices;
        } else if (this.service_spouse_add.department == 6) {
          return this.dentalServices;
        } else if (this.service_spouse_add.department == 7) {
          return this.antenatalServices;
        } else {
          return [];
        }
      }
    },
    // END FILTER SERVICES DEPENDING ON A SELECTED DEPARTMENT

    // GET SERVICE PRICE
    SevicesPrice: function () {
      if (this.opentmodal == 1) {
        if (this.service_add.department == 1) {
          return this.consultationServices.filter((ser) => {
            return ser.id == this.service_add.service;
          });
        } else if (this.service_add.department == 2) {
          return this.radiologyServices.filter((ser) => {
            return ser.id == this.service_add.service;
          });
        } else if (this.service_add.department == 3) {
          return this.procedureServices.filter((ser) => {
            return ser.id == this.service_add.service;
          });
        } else if (this.service_add.department == 4) {
          return this.labServices.filter((ser) => {
            return ser.id == this.service_add.service;
          });
        } else if (this.service_add.department == 6) {
          return this.dentalServices.filter((ser) => {
            return ser.id == this.service_add.service;
          });
        } else if (this.service_add.department == 7) {
          return this.antenatalServices.filter((ser) => {
            return ser.id == this.service_add.service;
          });
        } else {
          return "0";
        }
      } else {
        if (this.service_spouse_add.department == 1) {
          return this.consultationServices.filter((ser) => {
            return ser.id == this.service_spouse_add.service;
          });
        } else if (this.service_spouse_add.department == 2) {
          return this.radiologyServices.filter((ser) => {
            return ser.id == this.service_spouse_add.service;
          });
        } else if (this.service_spouse_add.department == 3) {
          return this.procedureServices.filter((ser) => {
            return ser.id == this.service_spouse_add.service;
          });
        } else if (this.service_spouse_add.department == 4) {
          return this.labServices.filter((ser) => {
            return ser.id == this.service_spouse_add.service;
          });
        } else if (this.service_spouse_add.department == 6) {
          return this.dentalServices.filter((ser) => {
            return ser.id == this.service_spouse_add.service;
          });
        } else if (this.service_spouse_add.department == 7) {
          return this.antenatalServices.filter((ser) => {
            return ser.id == this.service_spouse_add.service;
          });
        } else {
          return "0";
        }
      }
    },
    occupationCop: function () {
      return this.ant_data.occupation;
    },
    // END GET SERVER
  },

  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeMode(this.model_id);
        if (this.notificationtype == "success") {
          this.clearInputModel();
          this.$toast.success(this.notification_message.msg);
        } else {
          this.submitted = false;
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
    anteboiodata(newValue) {
      if (newValue) {
        if (this.AntePatientboiodata.fill_status == "fill") {
          this.setAnteData();
        }
      }
    },

    occupationCop(newValue) {
      if (newValue) {
        this.errors.occupation_error = "";
      }
    },
  },
  methods: {
    select_tab() {
      this.$refs.formWiz.changeTab(0, 6);
    },
    ...mapActions({
      FetchReligions: "antenatal/fetchReligions",
      FetchOccupations: "antenatal/fetchOccupations",
      FetchEducationLevels: "antenatal/fetchEducationLevels",
      FetchTribes: "antenatal/fetchTribes",
      FetchSpouse: "antenatal/fetchSpouse",
      SaveAntenatalBioData: "antenatal/SaveAntenatalBioData",
      FetchAntenatalBioData: "antenatal/fetchAntenatalBioData",
      FetchPateintAntenatalVisits: "antenatal/fetchPateintAntenatalVisits",

      FetchDiagnosisDetails: "doctor/fetchDiagnosisDetails",
      FetchOrderedConsultations: "visits/fetchOrderedConsultations",
      FetchOrderedProcedure: "visits/fetchOrderedProcedure",
      Add_Service: "visits/AddService",
      FetchOrderedRadiology: "visits/fetchOrderedRadiology",
      FetchAllOrderedServices: "visits/fetchAllOrderedServices",
      FetchOrderedDental: "visits/fetchOrderedDental",
      FetchPharmacyItems: "pharmacy/fetchPharmacyItems",
      AddPrescriptions: "prescriptions/addPrescriptions",
      UpdatePrescription: "prescriptions/updatePrescription",
      RemovePrescription: "prescriptions/removePrescription",
      FetchVisitPrescriptions: "prescriptions/fetchVisitPrescriptions",

      // SERVICES
      FetchLabServices: "services/fetchLabServices",
      FetchConsultationServices: "services/fetchConsultationServices",
      FetchRadiologyServices: "services/fetchRadiologyServices",
      FetchProcedureServices: "services/fetchProcedureServices",
      FetchDentalServices: "services/fetchDentalServices",
      FetchAntentalServices: "services/fetchAntenatalServices",
      FetchInsuranceServices: "insurance/fetchInsuranceServices",
    }),

    clearInputModel() {
      // ADD SERVICE
      (this.service_add = {
        department: "",
        insurance_company: "",
        insurance_status: "0",
        patientId: this.$route.params.id,
        patient_service: "",
        quantity: "1",
        service: "",
        spouse_status: 0,
        service_cost: "",
        visit_id: this.$route.params.visit,
      }),
        // ADD SPOUSE SERVICE
        (this.service_spouse_add = {
          department: "",
          insurance_company: "",
          insurance_status: "0",
          patientId: this.$route.params.id,
          patient_service: "",
          quantity: "1",
          service: "",
          spouse_id: "",
          spouse_status: 1,
          service_cost: "",
          visit_id: this.$route.params.visit,
        });
    },
    FinishUp() {
      this.$router.push({
        name: "Antenatal_VISIT_REPORT",
        params: { ante_visit: 1 },
      });
    },
    setmodelstatus(val) {
      this.opentmodal = val;
    },
    setAnteData() {
      this.ant_data = {
        insurance_status: 0,
        visit_id: this.$route.params.visit,
        patientId: this.$route.params.id,
        abortion: this.AntePatientboiodata ? this.AntePatientboiodata.abortions : "",
        asthma: this.AntePatientboiodata ? this.AntePatientboiodata.asthma : "",
        bloodtransfusion: this.AntePatientboiodata
          ? this.AntePatientboiodata.bloodTransfusion
          : "",
        cardiacdisease: this.AntePatientboiodata
          ? this.AntePatientboiodata.cardiacDisease
          : "",
        cesarean_section: this.AntePatientboiodata
          ? this.AntePatientboiodata.cesareanSection
          : "",
        diabetic: this.AntePatientboiodata ? this.AntePatientboiodata.diabetic : "",
        ectopicpregnancy: this.AntePatientboiodata
          ? this.AntePatientboiodata.ectopicpregnancy
          : "",
        education_level: this.AntePatientboiodata
          ? this.AntePatientboiodata.educLevel
          : "",

        epilepsy: this.AntePatientboiodata ? this.AntePatientboiodata.epilepsy : "",
        expecteddelivery: this.AntePatientboiodata.expectedDelivery
          ? this.AntePatientboiodata.expectedDelivery
          : "",
        family_history: this.AntePatientboiodata.familyHistory,
        foetalhearrate: this.AntePatientboiodata.max_ante_visit
          ? this.AntePatientboiodata.max_ante_visit.FoetalHearRate
          : "",
        fundalheight: this.AntePatientboiodata.max_ante_visit
          ? this.AntePatientboiodata.max_ante_visit.fundalHeight
          : "",
        gravida: this.AntePatientboiodata.gravida,
        hypertension: this.AntePatientboiodata.hyperTension,
        kidney_disease: this.AntePatientboiodata.kidneyDisease,
        lastmenstrationperiod: this.AntePatientboiodata.last_menstruation
          ? this.AntePatientboiodata.last_menstruation
          : "",
        majorsurgerystatus: this.AntePatientboiodata.majorSurgery,
        majorsurgery: this.AntePatientboiodata.majorSurgeryName,
        major_surgery_date: this.AntePatientboiodata.WhenMajorSurgery,
        major_surgery_hospital: this.AntePatientboiodata.majorSurgeryHospital,
        manualvacuumaspiration: this.AntePatientboiodata.manualVacuumAspiration,
        marital_status: this.AntePatientboiodata.maritalStatus,
        molarpregnancy: this.AntePatientboiodata.molarPregnancy,
        nextofkin: this.AntePatientboiodata.nextOfKeen,
        occupation: this.AntePatientboiodata.occupation,
        para: this.AntePatientboiodata.parity,
        physicalexamination: this.AntePatientboiodata.max_ante_visit
          ? this.AntePatientboiodata.max_ante_visit.physicalExamination
          : "",
        postpartumhemorrhage: this.AntePatientboiodata.postpartumHemorrhage,
        presentation: this.AntePatientboiodata.max_ante_visit
          ? this.AntePatientboiodata.max_ante_visit.presentation
          : "",
        relationshipwithnexofkeen: this.AntePatientboiodata.nextOfkeen_rel,
        religion: this.AntePatientboiodata.religion,
        retainedplacenta: this.AntePatientboiodata.retainedPlacenta,
        sicklecellanaemia: this.AntePatientboiodata.sickleCellAnaemia,
        smoke: this.AntePatientboiodata.smoke,
        spouse_contact: this.AntePatientboiodata.spouse
          ? this.AntePatientboiodata.spouse.spouse_contact
          : "",
        spousename: this.AntePatientboiodata.spouse
          ? this.AntePatientboiodata.spouse.spouse_name
          : "",
        tribe: this.AntePatientboiodata.tribe,
        tuberculosis: this.AntePatientboiodata.tuberCulosis,
        CesareanSectionmonthyear: this.AntePatientboiodata.CesareanSectionmonthyear,
        wherecesarean_section: this.AntePatientboiodata.cesareanSectionwhere,
      };
      this.select_tab();
    },
    // SAVE BIODATA
    saveBioData() {
      if (this.ant_data.occupation == "") {
        this.errors.occupation_error = "Please enter occupation";
        return;
      }
      this.SaveAntenatalBioData(this.ant_data);
    },
    // SAVE PRISCRIPTION
    add_newPrescription(model_id) {
      this.model_id = model_id;
      this.AddPrescriptions(this.priscription);
    },
    // ADD SERVICE
    addService(model_id) {
      this.model_id = model_id;
      this.Add_Service(this.service_add);
    },

    addSpouseService(model_id) {
      this.model_id = model_id;
      this.Add_Service(this.service_spouse_add);
    },
    // Calculate Expected delivery
    CalcurateExpectedDelivery() {
      var lastMenstration = new Date(this.ant_data.lastmenstrationperiod);
      lastMenstration.setDate(lastMenstration.getDate() + 273.75);
      var delivery = lastMenstration.toISOString().substr(0, 10);
      this.ant_data.expecteddelivery = delivery;
    },
    // CLOSE MODEL
    closeMode(model_id) {
      this.$nextTick(() => {
        this.$bvModal.hide(model_id);
      });

      this.service_add = {
        department: "",
        insurance_company: "",
        insurance_status: "0",
        patientId: this.$route.params.id,
        patient_service: "",
        quantity: "1",
        service: "",
        spouse_status: 0,
        service_cost: "",
        visit_id: this.$route.params.visit,
      };
      this.service_spouse_add = {
        department: "",
        insurance_company: "",
        insurance_status: "0",
        patientId: this.$route.params.id,
        patient_service: "",
        quantity: "1",
        service: "",
        spouse_id: "",
        spouse_status: 1,
        service_cost: "",
        visit_id: this.$route.params.visit,
      };
    },
    resetForm() {
      this.priscription = {
        visit_id: this.$route.params.visit,
        drug_id: "",
        is_insured: 0,
      };
      this.service_add = {
        department: "",
        insurance_company: "",
        insurance_status: "0",
        patientId: this.$route.params.id,
        patient_service: "",
        quantity: "1",
        service: "",
        spouse_id: "",
        service_cost: "",
        visit_id: this.$route.params.visit,
      };
    },
    // SET SERVICE PRICE
    getPrice() {
      this.service_add.service_cost = this.SevicesPrice[0].servicePrice;
      this.service_spouse_add.service_cost = this.SevicesPrice[0].servicePrice;
    },
    // END SET SERVICE PRICE

    // CLEAR SERVICES INPUTS
    clear_inputs() {
      this.service_add.service_cost = "";
    },
    // CLEAR SERVICES INPUT
    // END CLOSE MODEL
    // renewInfo() {
    // this.$refs.formWiz.prevTab();
    // },

    // Form wizard management

    beforeTabSwitch: function (s) {
      if (s === 2) {
        if (
          this.ant_data.occupation &&
          this.ant_data.tribe &&
          this.ant_data.religion &&
          this.ant_data.education_level &&
          this.ant_data.marital_status &&
          this.ant_data.marital_status &&
          this.ant_data.gravida &&
          this.ant_data.spousename &&
          this.ant_data.spouse_contact &&
          this.ant_data.para &&
          this.ant_data.abortion
        ) {
          return true;
        } else {
          // this.errors.occupation_error = "Please enter occupation";
          return false;
        }
      }
    },
  },
  created() {
    this.FetchAntenatalBioData(this.$route.params.id);
    this.FetchDiagnosisDetails(this.$route.params.visit);
    this.FetchPateintAntenatalVisits(this.$route.params.id);
    this.FetchVisitPrescriptions(this.$route.params.visit);
    this.FetchAllOrderedServices(this.$route.params.visit);
    this.FetchPharmacyItems();
    setTimeout(() => {
      this.FetchReligions();
      this.FetchOccupations();
      this.FetchEducationLevels();
      this.FetchTribes();
      // this.FetchSpouse();
    }, 5000);

    // FETCH SERVICES
    setTimeout(() => {
      this.FetchLabServices();
      this.FetchConsultationServices();
      this.FetchRadiologyServices();
      this.FetchProcedureServices();
      this.FetchDentalServices();
      this.FetchAntentalServices();
      this.FetchInsuranceServices();
    }, 10000);
  },

  // END VOICE MANAGEMENT
};
</script>
<style scoped>
.custom-table-header {
  background-color: rgb(83, 101, 255);
  color: #fff;
}
.custom-table-header-success {
  background-color: #34c34c;
  color: #fff;
}
.custom-table-header-prescription {
  background-color: rgb(154, 0, 201);
  color: #fff;
}
</style>
<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />
    <div class="row mt-2">
      <div class="col-lg-12 mb-1">
        <div class="d-print-none">
          <button @click="$router.go(-1)" class="btn btn-success mb-2">
            <i class="fas fa-arrow-circle-left"></i> Go Back
          </button>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">
              ANTENATAL DETAILS FOR

              <span class="text-info font-weight-bold"
                >{{
                  DiagnosisDetails.patient.patientName
                    ? DiagnosisDetails.patient.patientName.toUpperCase()
                    : "-------"
                }}
              </span>
            </h4>

            <b-spinner
              v-if="DiagnosisStatus"
              class="m-0"
              variant="primary"
              role="status"
            ></b-spinner>

            <div
              class="row mt-2"
              v-show="
                DiagnosisDetails.temp ||
                DiagnosisDetails.pressure ||
                DiagnosisDetails.weight ||
                DiagnosisDetails.pulse ||
                DiagnosisDetails.muac
              "
            >
              <div class="col-lg-12">
                <div class="table-responsive">
                  <table class="table table-bordered">
                    <tbody>
                      <tr>
                        <td>
                          Temperature :
                          <span class="text-primary">{{
                            DiagnosisDetails.temp
                              ? DiagnosisDetails.temp + " &#x2103;"
                              : "---"
                          }}</span>
                        </td>
                        <td>
                          Pressure :
                          <span class="text-primary">
                            {{
                              DiagnosisDetails.pressure
                                ? DiagnosisDetails.pressure + " mmHg"
                                : "---"
                            }}</span
                          >
                        </td>
                        <td>
                          Weight :
                          <span class="text-primary">
                            {{
                              DiagnosisDetails.weight
                                ? DiagnosisDetails.weight + " kg"
                                : "---"
                            }}</span
                          >
                        </td>
                        <td>
                          Pulse :
                          <span class="text-primary">
                            {{
                              DiagnosisDetails.pulse
                                ? DiagnosisDetails.pulse + " b/min"
                                : "---"
                            }}</span
                          >
                        </td>
                        <td>
                          Mauc :
                          <span class="text-primary">{{
                            DiagnosisDetails.muac ? DiagnosisDetails.muac + " cm" : "---"
                          }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <b-tabs content-class="p-3 text-muted">
              <b-tab active class="border-0">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>

                  <span class="d-none d-sm-inline-block">Active Visit</span>
                </template>

                <h4 class="card-title">ACTIVE VISIT</h4>

                <form-wizard
                  shape="tab"
                  color="#556ee6"
                  @on-change="saveBioData"
                  @on-complete="FinishUp()"
                  ref="formWiz"
                  :index="index"
                >
                  <tab-content
                    icon="mdi mdi-account-circle"
                    title="Bio Data"
                    :before-change="() => beforeTabSwitch(2)"
                  >
                    <div class="row mt-2">
                      <div class="col-md-3">
                        <label for="validationCustom01">Occupation</label>
                        <input
                          v-model="ant_data.occupation"
                          autocomplete="off"
                          class="form-control"
                          list="occupationlist"
                          id="exampleDataList"
                          placeholder="Enter Occupation"
                        />
                        <datalist id="occupationlist">
                          <option value="">Enter Occupation</option>
                          <option
                            v-for="(occupation, index) in Occupations ? Occupations : []"
                            :key="index"
                            :value="occupation.name"
                          ></option>
                        </datalist>
                        <div class="text-danger" v-if="errors.occupation_error">
                          <em>{{ errors.occupation_error }}</em>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <label for="validationCustom01">Religion</label>
                        <input
                          v-model="ant_data.religion"
                          autocomplete="off"
                          class="form-control"
                          list="religionlist"
                          id="exampleDataList"
                          placeholder="Enter religion"
                        />
                        <datalist id="religionlist">
                          <option value="">Enter Religion</option>
                          <option
                            v-for="(religion, index) in Religions ? Religions : []"
                            :key="index"
                            :value="religion.name"
                          ></option>
                        </datalist>
                      </div>

                      <div class="col-md-3">
                        <label for="validationCustom01">Tribe</label>
                        <input
                          v-model="ant_data.tribe"
                          autocomplete="off"
                          class="form-control"
                          list="tribelist"
                          id="exampleDataList"
                          placeholder="Enter tribe"
                        />
                        <datalist id="tribelist">
                          <option value="">Enter Tribe</option>
                          <option
                            v-for="(tribe, index) in Tribes ? Tribes : []"
                            :key="index"
                            :value="tribe.name"
                          ></option>
                        </datalist>
                      </div>
                      <div class="col-md-3">
                        <label for="validationCustom01">Education level</label>
                        <input
                          v-model="ant_data.education_level"
                          autocomplete="off"
                          class="form-control"
                          list="educationlevellist"
                          id="exampleDataList"
                          placeholder="Enter highest level of education"
                        />
                        <datalist id="educationlevellist">
                          <option value="">Enter Education Level</option>
                          <option
                            v-for="(educationlevel, index) in EducationLevels
                              ? EducationLevels
                              : []"
                            :key="index"
                            :value="educationlevel.name"
                          ></option>
                        </datalist>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-md-3">
                        <label for="validationCustom01">Marital status</label>
                        <select class="form-control" v-model="ant_data.marital_status">
                          <option value="">Select status</option>
                          <option value="1">Married</option>
                          <option value="0">Single</option>
                        </select>
                      </div>
                      <div class="col-md-3">
                        <label for="validationCustom01">Gravida</label>
                        <input
                          autocomplete="off"
                          v-model="ant_data.gravida"
                          id="validationCustom01"
                          type="number"
                          class="form-control"
                          placeholder="How many times have you concieved ?"
                        />
                      </div>
                      <div class="col-md-3">
                        <label for="validationCustom01">Next of Kin</label>
                        <input
                          autocomplete="off"
                          v-model="ant_data.nextofkin"
                          id="validationCustom01"
                          type="text"
                          class="form-control"
                          placeholder="Enter Next of Kin"
                        />
                      </div>

                      <div class="col-md-3">
                        <label for="validationCustom01"
                          >Relationship with (next of Kin)</label
                        >
                        <input
                          autocomplete="off"
                          v-model="ant_data.relationshipwithnexofkeen"
                          id="validationCustom01"
                          type="text"
                          class="form-control"
                          placeholder="Enter relationship"
                        />
                      </div>
                    </div>

                    <div class="row mt-2">
                      <div class="col-md-6">
                        <label for="validationCustom01">Spouse Name</label>
                        <input
                          autocomplete="off"
                          v-model="ant_data.spousename"
                          id="validationCustom01"
                          type="text"
                          class="form-control"
                          placeholder="Enter Spouse Name"
                        />
                      </div>
                      <div class="col-md-6">
                        <label for="validationCustom01">Spouse Contact</label>
                        <input
                          autocomplete="off"
                          v-model="ant_data.spouse_contact"
                          id="validationCustom01"
                          type="text"
                          class="form-control"
                          placeholder="Enter Spouse Contact"
                        />
                      </div>
                    </div>
                    <div class="form-group mt-2">
                      <label for="validationCustom01">Para/Parity</label>
                      <input
                        autocomplete="off"
                        v-model="ant_data.para"
                        id="validationCustom01"
                        type="number"
                        class="form-control"
                        placeholder="Enter number of live children"
                      />
                    </div>
                    <div class="form-group mt-2">
                      <label for="validationCustom01">Abortions </label>
                      <ckeditor
                        placeholder="Enter abortion details"
                        v-model="ant_data.abortion"
                        :editor="editor"
                      ></ckeditor>
                    </div>
                    <!-- end row -->
                  </tab-content>

                  <tab-content icon="mdi mdi-hospital-marker" title="Medical History">
                    <div class="row mt-2">
                      <div class="col-md-6">
                        <label for="validationCustom01"
                          >Have you had a Cardiac disease ?</label
                        >
                        <select class="form-control" v-model="ant_data.cardiacdisease">
                          <option value="">Select</option>
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                        </select>
                      </div>
                      <div class="col-md-6">
                        <label for="validationCustom01"
                          >Have you had Kidney disease ?</label
                        >
                        <select class="form-control" v-model="ant_data.kidney_disease">
                          <option value="">Select</option>
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                        </select>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-md-6">
                        <label for="validationCustom01">Do you have Hypertension ?</label>
                        <select class="form-control" v-model="ant_data.hypertension">
                          <option value="">Select</option>
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                        </select>
                      </div>
                      <div class="col-md-6">
                        <label for="validationCustom01"
                          >Do you have Tuber Culosis ?</label
                        >
                        <select class="form-control" v-model="ant_data.tuberculosis">
                          <option value="">Select</option>
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                        </select>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-md-6">
                        <label for="validationCustom01">Do you have Asthma ?</label>
                        <select class="form-control" v-model="ant_data.asthma">
                          <option value="">Select</option>
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                        </select>
                      </div>
                      <div class="col-md-6">
                        <label for="validationCustom01"
                          >Do you have Sickle cell anaemia ?</label
                        >
                        <select class="form-control" v-model="ant_data.sicklecellanaemia">
                          <option value="">Select</option>
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                        </select>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-md-6">
                        <label for="validationCustom01">Do you have Epilepsy?</label>
                        <select class="form-control" v-model="ant_data.epilepsy">
                          <option value="">Select</option>
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                        </select>
                      </div>
                      <div class="col-md-6">
                        <label for="validationCustom01">Are you diabetic ?</label>
                        <select class="form-control" v-model="ant_data.diabetic">
                          <option value="">Select</option>
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                        </select>
                      </div>
                    </div>
                  </tab-content>

                  <tab-content icon="bx bx-first-aid" title="Surgical History">
                    <div class="row mt-2">
                      <div class="col-md-6">
                        <label for="validationCustom01"
                          >Have you had any major surgery ?</label
                        >
                        <select
                          class="form-control"
                          v-model="ant_data.majorsurgerystatus"
                        >
                          <option value="">Select</option>
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                        </select>
                      </div>
                      <div class="col-md-6" v-show="ant_data.majorsurgerystatus == 1">
                        <label for="validationCustom01"
                          >which major surgery have you had ? ?</label
                        >
                        <input
                          autocomplete="off"
                          v-model="ant_data.majorsurgery"
                          type="text"
                          class="form-control"
                          placeholder="Major Surger name"
                        />
                      </div>
                      <div class="col-md-6" v-show="ant_data.majorsurgerystatus == 1">
                        <label for="validationCustom01"
                          >When was major surgery(year,month) ?</label
                        >
                        <input
                          autocomplete="off"
                          v-model="ant_data.major_surgery_date"
                          type="month"
                          class="form-control"
                        />
                      </div>
                      <div class="col-md-6" v-show="ant_data.majorsurgerystatus == 1">
                        <label for="validationCustom01"
                          >Which hospital was the surgery ?</label
                        >
                        <input
                          autocomplete="off"
                          v-model="ant_data.major_surgery_hospital"
                          type="text"
                          class="form-control"
                          placeholder="Enter hospital name"
                        />
                      </div>
                      <div class="col-md-6">
                        <label for="validationCustom01"
                          >Have you ever had any Blood Transfusion ?</label
                        >
                        <select class="form-control" v-model="ant_data.bloodtransfusion">
                          <option value="">Select</option>
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                        </select>
                      </div>
                    </div>
                  </tab-content>
                  <tab-content icon="mdi mdi-baby" title="Obstetrics and gynaecology">
                    <div class="row mt-2">
                      <div class="col-md-6">
                        <label for="validationCustom01"
                          >Have you had ectopic pregnancy ?</label
                        >
                        <select class="form-control" v-model="ant_data.ectopicpregnancy">
                          <option value="">Select</option>
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                        </select>
                      </div>
                      <div class="col-md-6">
                        <label for="validationCustom01"
                          >Have you had molar pregnancy ?</label
                        >
                        <select class="form-control" v-model="ant_data.molarpregnancy">
                          <option value="">Select</option>
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                        </select>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-md-6">
                        <label for="validationCustom01"
                          >Have you had Cesarean Section ?</label
                        >
                        <select class="form-control" v-model="ant_data.cesarean_section">
                          <option value="">Select</option>
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                        </select>
                      </div>
                      <div class="col-md-6" v-show="ant_data.cesarean_section == 1">
                        <label for="validationCustom01"
                          >When did you have Cesarean Section ?</label
                        >
                        <input
                          v-model="ant_data.CesareanSectionmonthyear"
                          type="month"
                          class="form-control"
                        />
                      </div>
                      <div class="col-md-6" v-show="ant_data.cesarean_section == 1">
                        <label for="validationCustom01"
                          >Where did you have Cesarean Section ?</label
                        >
                        <input
                          v-model="ant_data.wherecesarean_section"
                          type="text"
                          placeholder="Enter where you had cesareansection (Hospital)"
                          class="form-control"
                        />
                      </div>
                      <div class="col-md-6">
                        <label for="validationCustom01"
                          >Have you had Manual Vacuum Aspiration(MVA) Previously ?</label
                        >
                        <select
                          class="form-control"
                          v-model="ant_data.manualvacuumaspiration"
                        >
                          <option value="">Select</option>
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                        </select>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-md-6">
                        <label for="validationCustom01"
                          >Have you had a retained placenta ?</label
                        >
                        <select class="form-control" v-model="ant_data.retainedplacenta">
                          <option value="">Select</option>
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                        </select>
                      </div>
                      <div class="col-md-6">
                        <label for="validationCustom01"
                          >Have you had Postpartum hemorrhage (PPH ) ?</label
                        >
                        <select
                          class="form-control"
                          v-model="ant_data.postpartumhemorrhage"
                        >
                          <option value="">Select</option>
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                        </select>
                      </div>
                    </div>
                  </tab-content>
                  <tab-content icon="fa fa-users" title="Social And Family History">
                    <div class="form-group mt-2">
                      <label for="validationCustom01">Do you smoke?</label>
                      <select class="form-control" v-model="ant_data.smoke">
                        <option value="">Select</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                      </select>
                    </div>
                    <div class="form-group mt-2">
                      <label for="">Family History ?</label>
                      <ckeditor
                        v-model="ant_data.family_history"
                        :editor="editor"
                      ></ckeditor>
                    </div>
                  </tab-content>
                  <tab-content
                    icon="mdi mdi-human-baby-changing-table"
                    title="Menstruation(LMP) And Delivery (EDD)"
                  >
                    <div class="row mt-2">
                      <div class="col-md-6">
                        <label for="validationCustom01"
                          >Last Menstruation Period (LMP)?</label
                        >
                        <input
                          autocomplete="off"
                          @input="CalcurateExpectedDelivery()"
                          v-model="ant_data.lastmenstrationperiod"
                          id="validationCustom01"
                          type="date"
                          class="form-control"
                        />
                      </div>
                      <div class="col-md-6">
                        <label for="validationCustom01"
                          >Expected Delivery date (EDD)?</label
                        >
                        <input
                          autocomplete="off"
                          v-model="ant_data.expecteddelivery"
                          id="validationCustom01"
                          type="date"
                          class="form-control"
                        />
                      </div>
                    </div>
                  </tab-content>
                  <tab-content icon="bx bx-body" title="Physical Examination">
                    <div class="row mt-2">
                      <div class="col-md-12">
                        <label for="validationCustom01">Physical Examination</label>
                        <ckeditor
                          v-model="ant_data.physicalexamination"
                          :editor="editor"
                        ></ckeditor>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-md-6">
                        <label for="validationCustom01">Fundal Height</label>
                        <input
                          autocomplete="off"
                          v-model="ant_data.fundalheight"
                          id="validationCustom01"
                          type="text"
                          class="form-control"
                          placeholder="Enter Fundal Height"
                        />
                      </div>
                      <div class="col-md-6">
                        <label for="validationCustom01">Presentation</label>
                        <input
                          autocomplete="off"
                          v-model="ant_data.presentation"
                          id="validationCustom01"
                          type="text"
                          class="form-control"
                          placeholder="Enter Presentation"
                        />
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-md-12">
                        <label for="validationCustom01">FHR(Foetal Hear Rate)</label>
                        <input
                          autocomplete="off"
                          v-model="ant_data.foetalhearrate"
                          id="validationCustom01"
                          type="text"
                          class="form-control"
                          placeholder="Enter FHR(Foetal Hear Rate)"
                        />
                      </div>
                    </div>
                  </tab-content>
                  <tab-content icon="fa fa-flask" title="Lab Tests">
                    <div class="card">
                      <div class="card-body">
                        <h4 class="card-title">MOTHER LAB TESTS</h4>
                        <div class="row">
                          <div class="col-md-12">
                            <button
                              @click="setmodelstatus(1)"
                              v-b-modal.mother_add_service
                              class="btn btn-success mb-2 float-end"
                            >
                              <i class="fas fa-plus-circle"></i> Order New Service
                            </button>
                          </div>
                        </div>
                        <div class="table-responsive">
                          <table class="table mb-0">
                            <thead class="custom-table-header">
                              <tr>
                                <th scope="col">SERVICE</th>
                                <th scope="col">QTY</th>
                                <th scope="col">COST</th>
                                <th scope="col">TIME</th>
                                <th scope="col">STATUS</th>
                                <th scope="col">REMOVE</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(service, index) in getMotherService
                                  ? getMotherService
                                  : []"
                                :key="index"
                              >
                                <td>{{ service.service ? service.service : "--" }}</td>
                                <td>{{ service.quantity ? service.quantity : "--" }}</td>
                                <td>{{ service.cost ? service.cost : "--" }}</td>
                                <td>{{ service.date ? service.date : "--" }}</td>
                                <td>
                                  {{ service.status == "0" ? "Pending..." : "Done" }}
                                </td>
                                <td>
                                  <button class="btn btn-danger">
                                    <i class="fa fa-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div class="card mt-3">
                      <div class="card-body">
                        <h4 class="card-title">SPOUSE LAB TESTS</h4>
                        <div class="row">
                          <div class="col-md-12">
                            <button
                              @click="setmodelstatus(2)"
                              v-b-modal.spouses_add_service
                              class="btn btn-success mb-2 float-end"
                            >
                              <i class="fas fa-plus-circle"></i> Order New Service
                            </button>
                          </div>
                        </div>
                        <div class="table-responsive">
                          <table class="table mb-0">
                            <thead class="custom-table-header-success">
                              <tr>
                                <th scope="col">SERVICE</th>
                                <th scope="col">QTY</th>
                                <th scope="col">COST</th>
                                <th scope="col">TIME</th>
                                <th scope="col">STATUS</th>
                                <th scope="col">REMOVE</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(service, index) in getSpouseService
                                  ? getSpouseService
                                  : []"
                                :key="index"
                              >
                                <td>{{ service.service ? service.service : "--" }}</td>
                                <td>{{ service.quantity ? service.quantity : "--" }}</td>
                                <td>{{ service.cost ? service.cost : "--" }}</td>
                                <td>{{ service.date ? service.date : "--" }}</td>
                                <td>
                                  {{ service.status == "0" ? "Pending..." : "Done" }}
                                </td>
                                <td>
                                  <button class="btn btn-danger">
                                    <i class="fa fa-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </tab-content>
                  <tab-content icon="fa fa-capsules" title="Prescriptions">
                    <div class="card">
                      <div class="card-body">
                        <h4 class="card-title">Prescriptions</h4>
                        <div class="row">
                          <div class="col-md-12">
                            <button
                              v-b-modal.add_priscription
                              class="btn btn-success mb-2 float-end"
                            >
                              <i class="fas fa-plus-circle"></i> Add New
                            </button>
                          </div>
                        </div>
                        <div class="table-responsive">
                          <table class="table mb-0">
                            <thead class="custom-table-header">
                              <tr>
                                <th>S/N</th>
                                <th>Drug</th>
                                <th>Quantity</th>
                                <th>Cost</th>
                                <th>Payment Type</th>
                                <th>Medication</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(drug, index) in VisitPrescription" :key="index">
                                <th scope="row">{{ index + 1 }}</th>
                                <td>{{ drug.item.serviceName }}</td>
                                <td>{{ drug.itemQty }}</td>
                                <td>{{ drug.itemPrice }}</td>
                                <td>
                                  {{
                                    (drug.isInsured = 1
                                      ? "Insurance Bill"
                                      : "Personal Bill")
                                  }}
                                </td>
                                <td>{{ drug.medication ? drug.medication : "----" }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </tab-content>
                </form-wizard>
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">PREVIOUS VISITS</span>
                </template>

                <div role="tablist">
                  <b-card
                    no-body
                    class="mb-1 shadow-none"
                    v-for="(ante_visit, g) in patient_Antenatal_visits
                      ? patient_Antenatal_visits.slice().reverse()
                      : []"
                    :key="g"
                  >
                    <b-card-header
                      header-tag="header"
                      role="tab"
                      :style="
                        ante_visit.visit.status
                          ? 'background-color: #34c38f'
                          : 'background-color: blue'
                      "
                    >
                      <h6 class="m-0">
                        <a
                          v-b-toggle.accordion-1
                          class="text-light"
                          href="javascript: void(0);"
                          >Visit on {{ ante_visit.visit.visitDate }}
                          <sup v-if="ante_visit.visit.status" class="badge bg-success"
                            >Active</sup
                          >
                          <sup v-else style="background-color: blue">Closed</sup>
                        </a>
                      </h6>
                      <router-link
                        :to="{
                          name: 'Antenatal_VISIT_REPORT',
                          params: { ante_visit: ante_visit.biodata.max_ante_visit.id },
                        }"
                      >
                        <button class="btn btn-light float-end">
                          Print <i class="fa fa-print"></i>
                        </button>
                      </router-link>
                    </b-card-header>
                    <b-collapse
                      id="accordion-1"
                      visible
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body
                        :class="
                          ante_visit.visit.status
                            ? 'border border-success'
                            : 'border border-primary'
                        "
                      >
                        <b-card-text>
                          <div class="table-responsive">
                            <table class="table table-bordered">
                              <tbody>
                                <tr>
                                  <td>
                                    Temperature :
                                    <span class="text-primary">{{
                                      ante_visit.visit.temp
                                        ? ante_visit.visit.temp + " &#x2103;"
                                        : "---"
                                    }}</span>
                                  </td>
                                  <td>
                                    Pressure :
                                    <span class="text-primary">
                                      {{
                                        ante_visit.visit.pressure
                                          ? ante_visit.visit.pressure + " mmHg"
                                          : "---"
                                      }}</span
                                    >
                                  </td>
                                  <td>
                                    Weight :
                                    <span class="text-primary">
                                      {{
                                        ante_visit.visit.weight
                                          ? ante_visit.visit.weight + " kg"
                                          : "---"
                                      }}</span
                                    >
                                  </td>
                                  <td>
                                    Pulse :
                                    <span class="text-primary">
                                      {{
                                        ante_visit.visit.pulse
                                          ? ante_visit.visit.pulse + " b/min"
                                          : "---"
                                      }}</span
                                    >
                                  </td>
                                  <td>
                                    Mauc :
                                    <span class="text-primary">{{
                                      ante_visit.visit.muac
                                        ? ante_visit.visit.muac + " cm"
                                        : "---"
                                    }}</span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <div class="table-responsive">
                                <table class="table table-nowrap mb-0">
                                  <tbody>
                                    <tr>
                                      <th scope="row">Occupation :</th>
                                      <td>
                                        {{
                                          ante_visit.biodata.occupation
                                            ? ante_visit.biodata.occupation
                                            : "---"
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <th scope="row">Tribe :</th>
                                      <td>
                                        {{
                                          ante_visit.biodata.tribe
                                            ? ante_visit.biodata.tribe
                                            : "---"
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <th scope="row">Para/Parity</th>
                                      <td
                                        v-html="
                                          ante_visit.biodata.parity
                                            ? ante_visit.biodata.parity
                                            : '---'
                                        "
                                      ></td>
                                    </tr>
                                    <tr>
                                      <th scope="row">Next of keen</th>
                                      <td
                                        v-html="
                                          ante_visit.biodata.nextOfKeen
                                            ? ante_visit.biodata.nextOfKeen
                                            : '---'
                                        "
                                      ></td>
                                    </tr>
                                    <tr>
                                      <th scope="row">Spouse Name</th>
                                      <td
                                        v-html="
                                          ante_visit.biodata.spouse
                                            ? ante_visit.biodata.spouse.spouse_name
                                            : '---'
                                        "
                                      ></td>
                                    </tr>
                                    <tr>
                                      <th scope="row">Fundal Height :</th>
                                      <td
                                        v-html="
                                          ante_visit.fundalHeight
                                            ? ante_visit.fundalHeight
                                            : '---'
                                        "
                                      ></td>
                                    </tr>
                                    <tr>
                                      <th scope="row">Presentation :</th>
                                      <td
                                        v-html="
                                          ante_visit.presentation
                                            ? ante_visit.presentation
                                            : '---'
                                        "
                                      ></td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="table-responsive">
                                <table class="table table-nowrap mb-0">
                                  <tbody>
                                    <tr>
                                      <th scope="row">Religion :</th>
                                      <td>
                                        {{
                                          ante_visit.biodata.religion
                                            ? ante_visit.biodata.religion
                                            : "---"
                                        }}
                                      </td>
                                    </tr>

                                    <tr>
                                      <th scope="row">Education Level :</th>
                                      <td>
                                        {{
                                          ante_visit.biodata.educationlevel
                                            ? ante_visit.biodata.educationlevel
                                            : "---"
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <th scope="row">Gravida</th>
                                      <td
                                        v-html="
                                          ante_visit.biodata.gravida
                                            ? ante_visit.biodata.gravida
                                            : '---'
                                        "
                                      ></td>
                                    </tr>
                                    <tr>
                                      <th scope="row">Next of keen Relationship</th>
                                      <td
                                        v-html="
                                          ante_visit.biodata.nextOfkeen_rel
                                            ? ante_visit.biodata.nextOfkeen_rel
                                            : '---'
                                        "
                                      ></td>
                                    </tr>
                                    <tr>
                                      <th scope="row">Spouse Contact</th>
                                      <td
                                        v-html="
                                          ante_visit.biodata.spouse
                                            ? ante_visit.biodata.spouse.spouse_contact
                                            : '---'
                                        "
                                      ></td>
                                    </tr>
                                    <tr>
                                      <th scope="row">FHR(Foetal Hear Rate) :</th>
                                      <td>
                                        {{
                                          ante_visit.FoetalHearRate
                                            ? ante_visit.FoetalHearRate
                                            : "---"
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <th scope="row">Physical Examination :</th>
                                      <td
                                        v-html="
                                          ante_visit.physicalExamination
                                            ? ante_visit.physicalExamination
                                            : '---'
                                        "
                                      ></td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>

                          <div class="table-responsive mt-5">
                            <h5>ORDERED SERVICES</h5>

                            <table class="table mb-0">
                              <thead class="custom-table-header-info">
                                <tr>
                                  <th scope="col">SERVICE</th>
                                  <th scope="col">QTY</th>
                                  <th scope="col">COST</th>
                                  <th scope="col">TIME</th>
                                  <th scope="col">STATUS</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(service, index) in AllOrderedServices
                                    ? AllOrderedServices
                                    : []"
                                  :key="index"
                                >
                                  <td>
                                    <span v-if="service.spouse">
                                      <div style="color: green">
                                        {{ service.service }}
                                        <sup
                                          v-show="service.spouse"
                                          class="badge bg-success"
                                          >Spouse</sup
                                        >
                                      </div>
                                    </span>
                                    <span v-else>
                                      {{ service.service ? service.service : "--" }}
                                    </span>
                                  </td>
                                  <td>
                                    {{ service.quantity ? service.quantity : "--" }}
                                  </td>
                                  <td>
                                    {{ service.cost ? service.cost : "--" }}
                                  </td>
                                  <td>
                                    {{ service.date ? service.date : "--" }}
                                  </td>

                                  <td>
                                    {{ service.status == "0" ? "Pending..." : "Done" }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>

                          <div class="table-responsive mt-5">
                            <h4>DRUG PRESCRIPIONS</h4>
                            {{ ante_visit.prescriptions }}
                            <table class="table mb-0">
                              <thead>
                                <tr>
                                  <th>S/N</th>
                                  <th>Drug</th>
                                  <th>Quantity</th>
                                  <th>Cost</th>
                                  <th>Payment Type</th>
                                  <th>Medication</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(drug, index) in ante_visit.visit.prescriptions"
                                  :key="index"
                                >
                                  <th scope="row">{{ index + 1 }}</th>
                                  <td>{{ drug.item.serviceName }}</td>
                                  <td>{{ drug.itemQty }}</td>
                                  <td>{{ drug.itemPrice }}</td>
                                  <td>
                                    {{
                                      (drug.isInsured = 1
                                        ? "Insurance Bill"
                                        : "Personal Bill")
                                    }}
                                  </td>
                                  <td>
                                    {{ drug.medication ? drug.medication : "----" }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
        <!-- START PRESCRIPTION MODEL -->
        <b-modal
          id="add_priscription"
          title="Make A Prescription"
          ok-title="SAVE"
          hide-footer
        >
          <div class="form-group">
            <label class="col-form-label" for="password">Payment Type</label>
            <select class="form-control" v-model="priscription.insurance_status">
              <option v-for="(ty, index) in PaymentType" :key="index" :value="ty.id">
                {{ ty.name }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label class="col-form-label" for="userName"
              >Drug <span class="text-danger">*</span></label
            >
            <model-list-select
              :list="PharmacyItems ? PharmacyItems : []"
              v-model="priscription.drug_id"
              option-value="id"
              option-text="drug_name"
              placeholder="select drug"
            >
            </model-list-select>
          </div>
          <div class="form-group">
            <label class="col-form-label" for="userName"
              >Quantity <span class="text-danger">*</span></label
            >
            <input
              v-model="priscription.quantity"
              type="text"
              placeholder="Enter quantity"
              class="form-control"
            />
          </div>
          <div class="form-group">
            <label class="col-form-label" for="userName"
              >Medication <span class="text-danger">*</span></label
            >
            <textarea
              placeholder="Enter medication"
              v-model="priscription.medication"
              class="form-control"
              id="exampleFormControlTextarea3"
              rows="4"
            ></textarea>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary float-start"
              @click="closeMode('add_priscription')"
            >
              cancel
            </button>
            <button
              @click="add_newPrescription('add_priscription')"
              type="submit"
              class="btn btn-success"
            >
              Submit
              <b-spinner
                v-if="prescriptionStatus"
                class="m-0"
                small
                variant="light"
                role="status"
              ></b-spinner>
              <i v-else class="fa fa-check"></i>
            </button>
          </div>
        </b-modal>
        <!-- END PRESCRIPTION MODEL -->

        <!-- START MOTHET ADD SERVICE MODEL  -->

        <b-modal
          @hide="resetForm"
          id="mother_add_service"
          title="ADD SERVICE TO MOTHER"
          ok-title="SAVE"
          hide-footer
        >
          <div class="form-group">
            <label class="col-form-label" for="password">Payment Type</label>
            <select class="form-control" v-model="service_add.insurance_status">
              <option v-for="(ty, index) in PaymentType" :key="index" :value="ty.id">
                {{ ty.name }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label class="col-form-label" for="userName"
              >Department <span class="text-danger">*</span></label
            >
            <model-list-select
              :list="departments ? departments : []"
              v-model="service_add.department"
              option-value="id"
              option-text="name"
              placeholder="select Department"
            >
            </model-list-select>
          </div>
          <div class="form-group">
            <label class="col-form-label" for="confirmpass">Service</label>

            <model-list-select
              :list="filterSevices ? filterSevices : []"
              v-model="service_add.service"
              @input="getPrice()"
              option-value="id"
              option-text="serviceName"
              placeholder="select Service"
            >
            </model-list-select>
          </div>
          <div class="form-group">
            <label class="col-form-label" for="confirmpass">Service Price</label>

            <input
              v-model="service_add.service_cost"
              id="service_price"
              type="text"
              name="service_price"
              class="form-control"
              placeholder="Service price"
            />
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary float-start"
              @click="closeMode('mother_add_service')"
            >
              cancel
            </button>
            <button
              @click="addService('mother_add_service')"
              type="submit"
              class="btn btn-success"
            >
              Submit
              <b-spinner
                v-if="OrderServiceStatus"
                class="m-0"
                small
                variant="light"
                role="status"
              ></b-spinner>
              <i v-else class="fa fa-check"></i>
            </button>
          </div>
        </b-modal>
        <!-- END MOTHET ADD SERVICE MODEL -->

        <!-- START SPOUSE ADD SERVICE MODEL  -->
        <b-modal
          @hide="resetForm"
          id="spouses_add_service"
          title="ADD SERVICE TO SPOUSE"
          ok-title="SAVE"
          hide-footer
        >
          <div class="form-group">
            <label class="col-form-label" for="password">Payment Type</label>
            <select class="form-control" v-model="service_spouse_add.insurance_status">
              <option v-for="(ty, index) in PaymentType" :key="index" :value="ty.id">
                {{ ty.name }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label class="col-form-label" for="userName"
              >Department <span class="text-danger">*</span></label
            >
            <model-list-select
              :list="departments ? departments : []"
              v-model="service_spouse_add.department"
              option-value="id"
              option-text="name"
              placeholder="select Department"
            >
            </model-list-select>
          </div>
          <div class="form-group">
            <label class="col-form-label" for="confirmpass">Service</label>

            <model-list-select
              :list="filterSevices ? filterSevices : []"
              v-model="service_spouse_add.service"
              @input="getPrice()"
              option-value="id"
              option-text="serviceName"
              placeholder="select Service"
            >
            </model-list-select>
          </div>
          <div class="form-group">
            <label class="col-form-label" for="confirmpass">Service Price</label>

            <input
              v-model="service_spouse_add.service_cost"
              id="service_price"
              type="text"
              name="service_price"
              class="form-control"
              placeholder="Service price"
            />
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary float-start"
              @click="closeMode('spouses_add_service')"
            >
              cancel
            </button>
            <button
              @click="addSpouseService('spouses_add_service')"
              type="submit"
              class="btn btn-success"
            >
              Submit
              <b-spinner
                v-if="OrderServiceStatus"
                class="m-0"
                small
                variant="light"
                role="status"
              ></b-spinner>
              <i v-else class="fa fa-check"></i>
            </button>
          </div>
        </b-modal>
        <!-- END SPOUSE ADD SERVICE MODEL -->
      </div>
    </div>
  </Layout>
</template>
